<div class="component-viewer">
    <mat-card>
        <mat-card-header>
            <mat-card-title>My Account</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="row mt-2 mb-3">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            </div>
            <mat-tab-group>
                <mat-tab label="User Information">
                    <form [formGroup]="userForm" (ngSubmit)="onUserInfoSubmit()">
                        <div class="container-fluid mb-3">
                            <div class="row">
                                <div class="col-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>First Name</mat-label>
                                        <input matInput formControlName="firstName" required>
                                        <mat-error *ngIf="userForm.get('firstName').errors?.required">
                                            First name is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Last Name</mat-label>
                                        <input matInput formControlName="lastName" required>
                                        <mat-error *ngIf="userForm.get('lastName').errors?.required">
                                            Last name is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Email</mat-label>
                                        <input matInput formControlName="email" required type="email" readonly>
                                        <mat-error *ngIf="userForm.get('email').errors?.required">
                                            Email is required
                                        </mat-error>
                                        <mat-error *ngIf="userForm.get('email').errors?.email">
                                            Please enter a valid email
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Phone Number</mat-label>
                                        <input matInput formControlName="phoneNumber" required>
                                        <mat-error *ngIf="userForm.get('phoneNumber').errors?.required">
                                            Phone number is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col text-end">
                                <button mat-raised-button type="submit"
                                    [disabled]="!userForm.valid || isLoading">
                                    Save User Information
                                </button>
                            </div>
                        </div>
                    </form>
                </mat-tab>
                <mat-tab label="Organization">
                    <mat-tab-group [(selectedIndex)]="selectedTabIndex">
                        <mat-tab label="Details">
                            <form [formGroup]="organizationForm" (ngSubmit)="onOrganizationSubmit()">
                                <div class="container-fluid mb-3">
                                    <div class="row align-items-baseline">
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Organization Name</mat-label>
                                                <input matInput formControlName="organizationName" required>
                                                <mat-error *ngIf="organizationForm.get('organizationName').errors?.required">
                                                    Organization name is required
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6 d-flex align-items-center">
                                            <a mat-raised-button 
                                               
                                               [href]="stripeLoginLink?.url" 
                                               target="_blank"
                                               *ngIf="stripeLoginLink?.url">
                                                <mat-icon>account_balance</mat-icon>
                                                Stripe Dashboard
                                            </a>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>API Key</mat-label>
                                                <input matInput formControlName="widgetApiKey" readonly>
                                            </mat-form-field>
                                        </div>
                                        <button mat-fab (click)="regenerateApiKey()" type="button">
                                            <mat-icon>refresh</mat-icon>
                                        </button>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Timezone</mat-label>
                                                <mat-select formControlName="timezone" required>
                                                    <mat-option *ngFor="let timezone of usTimezones" [value]="timezone.value">
                                                        {{ timezone.label }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error *ngIf="organizationForm.get('timezone').errors?.required">
                                                    Timezone is required
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row align-items-baseline">
                                        <div class="col-6">
                                            <mat-form-field class="w-100 mt-3">
                                                <mat-label>Credit Card Fee {{ isFeePercentage ? '(%)' : '($)' }}</mat-label>
                                                <input matInput type="number" formControlName="creditCardFee" [min]="0"
                                                    [max]="isFeePercentage ? 100 : null" required>
                                                <span matSuffix *ngIf="isFeePercentage">%</span>
                                                <span matPrefix *ngIf="!isFeePercentage">$</span>
                                                <mat-error *ngIf="organizationForm.get('creditCardFee').errors?.required">
                                                    Credit card fee is required
                                                </mat-error>
                                                <mat-error *ngIf="organizationForm.get('creditCardFee').errors?.min">
                                                    Fee cannot be negative
                                                </mat-error>
                                                <mat-error *ngIf="organizationForm.get('creditCardFee').errors?.max">
                                                    Fee cannot exceed 100%
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-button-toggle-group formControlName="creditCardFeeType"
                                                (change)="onFeeTypeChange()">
                                                <mat-button-toggle
                                                    [value]="CreditCardFeeType.Percentage">Percentage</mat-button-toggle>
                                                <mat-button-toggle [value]="CreditCardFeeType.Fixed">Fixed
                                                    Amount</mat-button-toggle>
                                            </mat-button-toggle-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="container-fluid mb-3">
                                    <div class="row mt-3">
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <mat-label>Additional Email Address</mat-label>
                                                <input matInput formControlName="additionalEmail">
                                                <button mat-icon-button matSuffix (click)="addEmail()" type="button">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                                <mat-error *ngIf="organizationForm.get('additionalEmail').errors?.email">
                                                    Please enter a valid email address
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z4">
                                                <ng-container matColumnDef="email">
                                                    <th mat-header-cell *matHeaderCellDef> Email </th>
                                                    <td mat-cell *matCellDef="let email">{{ email }}</td>
                                                </ng-container>
                                                <ng-container matColumnDef="remove">
                                                    <th mat-header-cell *matHeaderCellDef> </th>
                                                    <td mat-cell *matCellDef="let email">
                                                        <button mat-icon-button color="warn" (click)="removeEmail(email)"
                                                            type="button">
                                                            <mat-icon>remove</mat-icon>
                                                        </button>
                                                    </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef="['email', 'remove']"></tr>
                                                <tr mat-row *matRowDef="let row; columns: ['email', 'remove'];"></tr>
                                            </table>
                                        </div>
                                    </div>
                                    <mat-error *ngIf="emailErrorMessage">{{ emailErrorMessage }}</mat-error>
                                </div>
                                <div class="row mt-3">
                                    <div class="col text-end">
                                        <button mat-raised-button type="submit"
                                            [disabled]="!organizationForm.valid || isLoading">
                                            Save Organization Information
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="Plans">
                            <simbook-plans [isActive]="selectedTabIndex === 1"></simbook-plans>
                        </mat-tab>
                        <mat-tab label="Payment Methods">
                            <my-account-payment-methods></my-account-payment-methods>
                        </mat-tab>
                        <mat-tab label="Invoices">
                            <invoice-list [isActive]="selectedTabIndex === 3"></invoice-list>
                        </mat-tab>
                        <mat-tab label="Booking Settings">
                            <booking-settings [isActive]="selectedTabIndex === 4"></booking-settings>
                        </mat-tab>
                    </mat-tab-group>
                </mat-tab>
                <mat-tab label="Operating Hours">
                    <div class="container-fluid mt-3">
                        <div class="row">
                            <div class="col-12">
                                <mat-card class="operating-hours-card">
                                    <mat-card-content>
                                        <table class="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th class="col-2">Day</th>
                                                    <th class="col-2">Open</th>
                                                    <th class="col-7">Hours</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let day of operatingHours">
                                                    <td>{{days[day.dayOfWeek].label}}</td>
                                                    <td>
                                                        <mat-slide-toggle [(ngModel)]="day.isOpen"
                                                            (change)="toggleDayOpen(day)">
                                                        </mat-slide-toggle>
                                                    </td>
                                                    <td>
                                                        <div class="d-flex align-items-center gap-3">
                                                            <div class="flex-grow-1">
                                                                <mat-form-field appearance="outline" class="w-100">
                                                                    <mat-select [(ngModel)]="day.openTime"
                                                                        [disabled]="!day.isOpen">
                                                                        <mat-option *ngFor="let time of timeOptions"
                                                                            [value]="time.value">
                                                                            {{time.display}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>
                                                            </div>
                                                            <span>to</span>
                                                            <div class="flex-grow-1">
                                                                <mat-form-field appearance="outline" class="w-100">
                                                                    <mat-select [(ngModel)]="day.closeTime"
                                                                        [disabled]="!day.isOpen">
                                                                        <mat-option *ngFor="let time of timeOptions"
                                                                            [value]="time.value">
                                                                            {{time.display}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>
                                                            </div>
                                                            <mat-checkbox [(ngModel)]="day.isNextDay" 
                                                                         [disabled]="!day.isOpen"
                                                                         matTooltip="Check if closing time is next day">
                                                                Is Next Day
                                                            </mat-checkbox>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        
                                        <div class="text-danger mb-3" *ngIf="operatingHoursErrorMessage.day">
                                            {{ operatingHoursErrorMessage.day }}: {{ operatingHoursErrorMessage.message }}
                                        </div>
                                        
                                        <div class="d-flex justify-content-end mt-3">
                                            <button mat-raised-button 
                                                (click)="saveOperatingHours()"
                                                [disabled]="isLoading">
                                                Save Operating Hours
                                            </button>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-card>
</div>